import React from "react";
import './sponsorship.css';

export const SponsorshipPackages = () => {
    return (
        <div>
            <div className="mt-[74px] px-4 pt-2 bg-white flex items-center justify-center">
            </div>
            <div className="container mx-auto px-4 lg:px-8 lg:pb-12 mt-12">
                <h1 className="text-3xl font-bold text-center text-[#e94607]">Sponsorship</h1>
                <div className="mt-4 text-lg">
                    <p>Sponsors will have the opportunity to reach over 400-500 experts in the fields of semantic web technologies, including researchers and industry practitioners such as developers and engineering managers. </p>
                    <p>We are pleased to announce five levels of sponsorship: Bronze, Silver, Gold, Platinum and Diamond. In addition, we offer several ‘à la carte’ options tailored to your company profile and needs and linked to specific aspects of the conference.</p>
                </div>
                
                <br />
                <h2 className="h2-border-bottom">Diamond (9.000$ / 1.400.000¥)</h2>
                <ol>
                    <li>Job posting for your company on the conference website</li>
                    <li>Logo displayed prominently on the conference website</li>
                    <li>Logo displayed before keynote talks and between talks</li>
                    <li><b>Logo displayed during opening and closing sessions</b></li>
                    <li>Acknowledgment of support in ISWC 2025 proceedings</li>
                    <li><b>Three social media posts advertising webpage (as a sponsor) between June 2025 and the conference days</b></li>
                    <li><b>Three free registrations</b></li>
                    <li>30-sec video/demo/talk that you provide to be played before each keynote session</li>
                    <li>Opportunity to be named as sponsor for the prize of one of the best paper awards at the conference (best research paper, best in-use paper, best resource, best student paper, best doctoral, best demo or poster) – priority on choosing the preferred awards (among the ones not assigned already)</li>
                    <li>Access to the Job Fair CV repository and a table at the Job Fair event at the conference, conditioned to enough interest for it from sponsors (and candidate)</li>
                    <li>Promotional banquet at the conference venue (if interested)</li>
                    <li>Promotional material at the conference venue</li>
                    <li><b>Sponsored industry talk at the conference (same duration of paper presentations) illustrating uses cases related to the conference topics (the topic of the talk is discussed with sponsor chairs in advance) (1–page abstract submitted in advance and approved by the Program Chairs / “sponsored talk” explicitly indicated in the program, not included in the proceedings)</b></li>
                </ol>
                
                <br />
                <h2 className="h2-border-bottom">Platinum (6.000 $ / 930.000 ¥)</h2>
                <ol>
                    <li>Job posting for your company on the conference website</li>
                    <li>Logo displayed prominently on the conference website</li>
                    <li><b>Logo displayed before keynote talks and between talks</b></li>
                    <li><b>Logo displayed during the opening speech</b></li>
                    <li>Acknowledgement of support in ISWC 2025 proceedings</li>
                    <li><b>Two social media posts advertising webpage (as a sponsor) between June 2025 and the conference days</b></li>
                    <li><b>Two free registrations</b></li>
                    <li><b>30-sec video/demo/talk that you provide to be played before each keynote session</b></li>
                    <li><b>Opportunity to be named as sponsor for the prize of one of the best paper awards at the conference (best research paper, best in-use paper, best resource, best student paper, best demo or poster) – choice of award is on a first-come first-served basis.</b></li>
                    <li>Access to the Job Fair CV repository and a table at the Job Fair event at the conference, conditioned to enough interest for it from sponsors (and candidate)</li>
                    <li><b>Promotional banquet at the conference venue (if interested)</b></li>
                    <li>Promotional material at the conference venue</li>
                </ol>

                <br />
                <h2 className="h2-border-bottom">Gold (4.000 $ / 620.000¥)</h2>
                <ol>
                    <li>Job posting for your company on the conference website</li>
                    <li>Logo displayed prominently on the conference website</li>
                    <li>Logo displayed between talks</li>
                    <li>Acknowledgement of support in ISWC 2025 proceedings</li>
                    <li><b>One social media post advertising webpage (as a sponsor) between June 2025 and the conference days</b></li>
                    <li><b>Access to the Job Fair CV repository and a table at the Job Fair event at the conference, conditioned to enough interest for it from sponsors (and candidate)</b></li>
                    <li>One free registration</li>
                    <li>Promotional material at the conference venue</li>
                </ol>

                <br />
                <h2 className="h2-border-bottom">Silver (2.500 $ / 390.000¥)</h2>
                <ol>
                    <li><b>Job posting for your company on the conference website</b></li>
                    <li>Logo displayed prominently on the conference website</li>
                    <li><b>Logo displayed between talks</b></li>
                    <li><b>Acknowledgement of support in ISWC 2025 proceedings</b></li>
                    <li><b>One free registration</b></li>
                    <li>Promotional material at the conference venue</li>
                </ol>
                
                <br />
                <h2 className="h2-border-bottom">Bronze (1.500 $ / 230.000¥)</h2>
                <ol>
                    <li>Logo displayed prominently on the conference website</li>
                    <li>Promotional material at the conference venue</li>
                </ol>

                <br />
                <h2 className="h2-border-bottom">À la carte Sponsorship Opportunities</h2>

                <h3>Doctoral Consortium Sponsor <b>[exclusive] (1.000 $ / 160.000¥)</b></h3>
                <ol>
                    <li>Logo displayed prominently on the conference website</li>
                    <li>Acknowledgment of support in the Doctoral Consortium proceedings</li>
                </ol>

                <br />
                <h3>Posters and Demo Reception <b>(500 $ / 80.000¥)</b></h3>
                <ol>
                    <li>Banner during the event</li>
                    <li>Sponsor's table and chair for demos</li>
                </ol>
            </div>
        </div>
    );
};

export default SponsorshipPackages;